import { AccountParameter, AccountTransaction, CalculatorResult, ContractTemplate, FinancialContract, FinancialObligationParameter, ParameterTypeEnum, PayrollParameters, ScheduleDate, WithdrawProperty } from '@akiba/models_beta_temp';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Alert } from '../misc/interfaces';
import { AlertComponent } from '../ui/alert/alert.component';
import { AkibaThemeService } from './akiba-theme.service';
import {TranslateService} from '@ngx-translate/core';
import { firstValueFrom, take } from 'rxjs';
import { GenericButtonTextEnum } from '../misc/enums';
import { CancelConfirmModalComponent } from '../prompts/cancel-confirm-modal/cancel-confirm-modal.component';
import { ApproveDenyComponent } from '../prompts/approve-deny/approve-deny.component';
import { CreateParameterModalComponent } from '../prompts/create-parameter-modal/create-parameter-modal.component';
import { CreatePayrollModalComponent } from '../prompts/create-payroll-modal/create-payroll-modal.component';
import { CreateLockDatesModalComponent } from '../prompts/create-lock-dates-modal/create-lock-dates-modal.component';
import { CreateTemplateModalComponent } from '../prompts/create-template-modal/create-template-modal.component';
import { CreateCompanyWithdrawModalComponent } from '../prompts/create-company-withdraw-modal/create-company-withdraw-modal.component';
import { WithdrawSimulationModalComponent } from '../prompts/withdraw-simulation-modal/withdraw-simulation-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { InfoConfirmComponent } from '../prompts/info-confirm/info-confirm.component';

@Injectable({
  providedIn: 'any'
})
export class UiService {


  keepSpinnerVisible: boolean = false;
  constructor(private modalService: NgbModal, public theme: AkibaThemeService, private translateService: TranslateService, private spinner: NgxSpinnerService) { }

  showInfoMessage(alert: Alert): void {
    const infoRef = this.modalService.open(AlertComponent, {backdrop: false});
    infoRef.componentInstance.alert = alert;
  }

  async showSpinner(name: string | undefined = undefined): Promise<void> {

    if (this.keepSpinnerVisible) {
      return;
    }

    await this.spinner.show(name);
    return;

  }

  async hideSpinner(name: string | undefined = undefined): Promise<void> {

    if (this.keepSpinnerVisible) {
      return;
    }

    await this.spinner.hide(name);
    return;

  }

  async showInfoConfirmMessage(aMessage: string, acceptButtonText: GenericButtonTextEnum = GenericButtonTextEnum.Accept): Promise<void> {

    const acceptText = await this.translateText(acceptButtonText);
    const tMessage = await this.translateText(aMessage);

    const dialogConfirmationRef = this.modalService.open(InfoConfirmComponent);
    dialogConfirmationRef.componentInstance.message = tMessage;
    dialogConfirmationRef.componentInstance.acceptButtonText = acceptText;

  }

  async showConfirmMessage(aMessage: string, cancelButtonText: GenericButtonTextEnum = GenericButtonTextEnum.Cancel, acceptButtonText: GenericButtonTextEnum = GenericButtonTextEnum.Accept): Promise<boolean> {

    const cancelText = await this.translateText(cancelButtonText);
    const acceptText = await this.translateText(acceptButtonText);

    const tMessage = await this.translateText(aMessage);

    const dialogConfirmationRef = this.modalService.open(CancelConfirmModalComponent);
    dialogConfirmationRef.componentInstance.message = tMessage;
    dialogConfirmationRef.componentInstance.cancelButtonText = cancelText;
    dialogConfirmationRef.componentInstance.acceptButtonText = acceptText;

    return await dialogConfirmationRef.result.then((res) => res).catch(() => false);

  }

  async showApproveDeny(financialContract: FinancialContract, approved: boolean): Promise<FinancialContract | undefined> {

    const component = this.modalService.open(ApproveDenyComponent);
    component.componentInstance.financialContract = financialContract;
    component.componentInstance.approved = approved;
    return await component.result.then((res) => res).catch(() => undefined);

  }

  async showApproveDenyDirectDeposit(transaction: AccountTransaction, approved: boolean): Promise<AccountTransaction | undefined> {

    const component = this.modalService.open(ApproveDenyComponent);
    component.componentInstance.accountTransaction = transaction;
    component.componentInstance.approved = approved;
    return await component.result.then((res) => res).catch(() => undefined);

  }

  async showCreateParameter(type: ParameterTypeEnum): Promise<AccountParameter | FinancialObligationParameter | undefined> {

    const createParameterComponent = this.modalService.open(CreateParameterModalComponent);
    createParameterComponent.componentInstance.parameterType = type;
    createParameterComponent.componentInstance.procType();
    return await createParameterComponent.result.then((res) => res).catch(() => undefined);

  }

  async showCreatePayroll(type: ParameterTypeEnum): Promise<PayrollParameters | undefined> {

    const createParameterComponent = this.modalService.open(CreatePayrollModalComponent);
    createParameterComponent.componentInstance.parameterType = type;
    createParameterComponent.componentInstance.procType();
    return await createParameterComponent.result.then((res) => res).catch(() => undefined);

  }

  async showCreateLockDates(type: ParameterTypeEnum): Promise<CreateLockDatesModalComponent | undefined> {

    const createParameterComponent = this.modalService.open(CreateLockDatesModalComponent);
    createParameterComponent.componentInstance.parameterType = type;
    createParameterComponent.componentInstance.procType();
    return await createParameterComponent.result.then((res) => res).catch(() => undefined);

  }

  async showCreateTemplate(): Promise<ContractTemplate | undefined> {

    const createParameterComponent = this.modalService.open(CreateTemplateModalComponent);
    createParameterComponent.componentInstance.procType();
    return await createParameterComponent.result.then((res) => res).catch(() => undefined);

  }

  async showCreateCompanyWithdraw(): Promise<WithdrawProperty | undefined> {

    const createParameterComponent = this.modalService.open(CreateCompanyWithdrawModalComponent);
    createParameterComponent.componentInstance.procType();
    return await createParameterComponent.result.then((res) => res).catch(() => undefined);

  }

  showWithdrawSimulation(cr: CalculatorResult, current: ScheduleDate): void {

    const component = this.modalService.open(WithdrawSimulationModalComponent);
    component.componentInstance.cr = cr;
    component.componentInstance.current = current;

  }

  async translateText(key: string): Promise<string> {
    const takeR = this.translateService.get(key).pipe(take(1));
    const tText = await firstValueFrom(takeR);
    return tText;
  }



}
